import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import { Spacer, Text, Paragraph, Button, BUTTON_TYPES } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { trackGAMortgageEvent } from '../analytics.js';
import { OUTCOME } from '../constants.js';
import { getPrequalUrl, getZGMICustomQuoteUrl, getCreditScoreArticleUrl, getDownPaymentAssistanceUrl, getPayOffDebtsGuideUrl } from '../url.js';
import jsxRuntime from '../../../node_modules/react/jsx-runtime.js';

var _excluded = ["outputs"];
var _CONTENT;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CONTENT = (_CONTENT = {}, _defineProperty(_CONTENT, OUTCOME.ZHL_PREQUAL, {
  description: 'Take the next step to verify your budget by getting pre-qualified.',
  ctaText: 'Get pre-qualified',
  getUrl: getPrequalUrl
}), _defineProperty(_CONTENT, OUTCOME.ZGMI_CQ, {
  description: 'Compare rates from multiple lenders, all in one place.',
  ctaText: 'See today’s rates',
  getUrl: getZGMICustomQuoteUrl
}), _defineProperty(_CONTENT, OUTCOME.LOW_CREDIT, {
  description: 'Building your credit score could help you qualify for a loan.',
  ctaText: 'Learn more',
  getUrl: getCreditScoreArticleUrl
}), _defineProperty(_CONTENT, OUTCOME.LOW_DOWN_PAYMENT, {
  description: 'Down payment assistance can help you lower the amount you need to save for a down payment.',
  ctaText: 'Learn more',
  getUrl: getDownPaymentAssistanceUrl
}), _defineProperty(_CONTENT, OUTCOME.HIGH_DEBT, {
  description: 'Paying off your debts could help you qualify for a loan.',
  ctaText: 'Learn more',
  getUrl: getPayOffDebtsGuideUrl
}), _CONTENT);
var PrimaryCta = function PrimaryCta(_ref) {
  var outputs = _ref.outputs,
    restProps = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    if (outputs.outcome) {
      var _ctaText = CONTENT[outputs.outcome].ctaText;
      trackGAMortgageEvent('Budget Calculator: Impression', "Calculator Primary CTA ".concat(_ctaText));
    }
  }, [outputs.outcome]);
  if (!outputs.outcome) {
    return null;
  }
  var _CONTENT$outputs$outc = CONTENT[outputs.outcome],
    description = _CONTENT$outputs$outc.description,
    ctaText = _CONTENT$outputs$outc.ctaText,
    getUrl = _CONTENT$outputs$outc.getUrl;
  var ctaHref = getUrl(outputs);
  return /*#__PURE__*/jsxRuntime.jsxs(Spacer, _objectSpread(_objectSpread({
    marginX: "md"
  }, restProps), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx(Text, {
      fontType: "bodyHeading",
      marginTop: "sm",
      children: "What's next?"
    }), /*#__PURE__*/jsxRuntime.jsx(Paragraph, {
      fontType: "bodySmall",
      children: description
    }), /*#__PURE__*/jsxRuntime.jsx(Button, {
      as: "a",
      href: ctaHref,
      onClick: function onClick() {
        return trackGAMortgageEvent('Budget Calculator: Click', "Calculator Primary CTA \"".concat(ctaText, "\""));
      },
      buttonType: BUTTON_TYPES.primary,
      marginTop: "md",
      fluid: true,
      children: ctaText
    })]
  }));
};
PrimaryCta.propTypes = {
  outputs: PropTypes.object
};
var PrimaryCta$1 = PrimaryCta;

export { PrimaryCta$1 as default };
//# sourceMappingURL=PrimaryCta.js.map
